module.exports = __webpack_public_path__ + "static/media/QueenswayLogo.ed0dcfe5.jpg";